import { ColorSpace, cmyk, keepCmyk, noCmyk, srgb, tinySrgb, trueColor } from "@cloudinary/transformation-builder-sdk/qualifiers/colorSpace";
export { ColorSpace, cmyk, keepCmyk, noCmyk, srgb, tinySrgb, trueColor };
